/* eslint-disable */
import React, { useState } from 'react';
import polygon from '../../images/icons/polygon.svg';
import getPoApprovalFlowLog from './queries/getPoApprovalFlowLog';

/**
 * Fetches and displays approval flow log for a PO.
 * API response: array of { id, purchaseOrderId, approvalLevel, description, logDate, userName }.
 */
const ApprovalFlowLog = ({ poId, approvals: approvalsProp = [], disabled = false }) => {
  const [open, setOpen] = useState(true);

  const { data: apiApprovals = [], isLoading } = getPoApprovalFlowLog(poId);
  const isSingleLog = apiApprovals && typeof apiApprovals === 'object' && !Array.isArray(apiApprovals)
    && (apiApprovals.logDate != null || apiApprovals.userName != null || apiApprovals.approvalLevel != null);
  const list = Array.isArray(apiApprovals)
    ? apiApprovals
    : (isSingleLog ? [apiApprovals] : []);
  const approvals = list.length > 0 ? list : approvalsProp;

  const formatDate = (d) => {
    if (!d) return '-';
    try {
      const dt = new Date(d);
      return dt.toLocaleDateString('en-GB');
    } catch (e) {
      return d;
    }
  };

  const formatRow = (a) => {
    return {
      date: a.logDate ?? a.date ?? a.approvalDate ?? a.createdDate ?? a.createdOn,
      user: a.userName ?? a.user ?? a.approverName ?? a.approvedBy,
      level: a.approvalLevel ?? a.level ?? a.approverLevel,
      comment: a.description ?? a.comment ?? a.comments ?? a.approvalComments
    };
  };

  return (
    <div className="my-4">
      <div
        onClick={() => setOpen((s) => !s)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setOpen((s) => !s)}
        aria-expanded={open}
        className={`flex flex-row place-content-between mb-4 mt-4 p-1 px-2.5 rounded-md cursor-pointer bg-secondary-500 ${disabled ? 'cursor-not-allowed' : 'bg-primary-300'}`}
        
      >
        <div className="text-base font-muli text-white-light font-bold">Approval Flow Log</div>
        <img src={polygon} alt="toggle" className={`${!open ? 'transform -rotate-90' : ''} w-6`} />
      </div>

      {open && (
        <div className="p-0 rounded bg-white">
          {isLoading && (
            <div className="py-6 px-4 text-center text-gray-400">Loading approval log...</div>
          )}
          {!isLoading && (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="text-left font-semibold py-3 px-4">Date</th>
                    <th className="text-left font-semibold py-3 px-4">User</th>
                    <th className="text-left font-semibold py-3 px-4">Approver Level</th>
                    <th className="text-left font-semibold py-3 px-4">Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {(approvals || []).length === 0 && (
                    <tr>
                      <td colSpan={4} className="py-6 px-4 text-center text-gray-400">No approval logs found</td>
                    </tr>
                  )}
                  {(approvals || []).map((a, idx) => {
                    const row = formatRow(a);
                    return (
                      <tr key={a?.id ?? `approval-log-${idx}`} className="border-t">
                        <td className="py-4 px-4">{formatDate(row.date)}</td>
                        <td className="py-4 px-4">{row.user || '-'}</td>
                        <td className="py-4 px-4">{row.level || '-'}</td>
                        <td className="py-4 px-4">{row.comment || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ApprovalFlowLog;
